import {
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { ColDef } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule } from '@angular/material/core';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';


import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from '@angular/forms';
import { noSpaceAtStartOrEnd } from '../../helpers/helper';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ToastrService } from 'ngx-toastr';
import { ReactiveFormsModule } from '@angular/forms';
import { PurchaseService } from '../../features/purchase/services/purchase.service';


@Component({
  selector: 'app-purchase-details',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatDatepickerModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './purchase-details.component.html',
  styleUrl: './purchase-details.component.scss',
})
export class PurchaseDetailsComponent implements OnInit {
  // selectedTabIndex = 0; // Default to the first tab
  public sideRowData: any[] | null = null;
  public tableData: any[] | null = null;
  public selectedTabIndex: number = 0;
  public selectedExpense: any = null;
  public tableItems: any[] = [];
  searchTerm: string = '';
  readonly dialog = inject(MatDialog);
  private toastr = inject(ToastrService);



  itemId: any;
  returnRequestId: any;
  itemData: any = {};
  allItems: any[] = [];
  public loading: boolean = true;
  private searchSubject = new Subject<string>();
  selectedCount: number = 0;
  projectDropdownItems: any[] = [];
  private searchSubjectRequest = new Subject<string>();
  selectedModes: string[] = [];

  requestItems: any[] = [];

  selectedItems: { [key: number]: boolean } = {}; //

  itemRequestData: any = {};

  loggedInUserId: number | null = null;
  loggedInUserFirstName: string = '';
  loggedInUserLastName: string = '';

  pageType: string | null = null;
  returnRequestData: any = {};

  returnRequestForm!: FormGroup;

  private searchSubjectReturnRequest = new Subject<string>();
  private purchaseService = inject(PurchaseService);
  dailyExpenseId: any = null;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.fetchDailyExpense();

    this.route.paramMap.subscribe((params) => {
      this.dailyExpenseId = params.get('id');

      if (this.dailyExpenseId) {
        const selectedId = Number(this.dailyExpenseId);
        if (this.sideRowData?.length) {
          this.setSelectedTab(selectedId);
        }

        this.fetchDailyExpenseById(selectedId);
      }
    });

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchDailyExpense(searchTerm);
      });
  }

  setActiveTab(index: number) {
    this.selectedTabIndex = index;
    const selectedId = this.sideRowData?.[index]?.id;
    if (selectedId) {
      // this.fetchDailyExpenseById(selectedId);
      this.router.navigate([`daily-purchase/purchase-details/${selectedId}`]);
    }
  }

  setSelectedTab(selectedId: number) {
    if (this.sideRowData && this.sideRowData.length > 0) {
      const index = this.sideRowData.findIndex(
        (expense) => expense.id === selectedId
      );
      if (index !== -1) {
        this.selectedTabIndex = index;
      }
    }
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value.trim();
    this.searchSubjectReturnRequest.next(searchTerm);
    this.searchSubject.next(searchTerm);
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  isDropdownOpen = false;
  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  clearFilters() {
    this.selectedModes = [];
    this.selectedCount = 0;
  }


  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10, 25, 50];
  public themeClass: string = 'ag-theme-quartz';

  fetchDailyExpense(search = '') {
    this.purchaseService.fetchDailyExpense(search).subscribe({
      next: (data) => {
        this.sideRowData = data.map((dailyExpense: any) => ({
          id: dailyExpense?.id,
          supplierName: dailyExpense?.supplierData?.supplierName || '--',
          code: dailyExpense?.dailyExpenseNo || '--',
        }));

        if (this.dailyExpenseId) {
          this.setSelectedTab(Number(this.dailyExpenseId));
        }
      },
      error: (error) => {
        console.error('Error fetching daily expenses:', error);
      },
    });
  }

  fetchDailyExpenseById(id: any) {
    this.purchaseService.fetchDailyExpenseById(id).subscribe({
      next: (data) => {
        this.tableData = [
          {
            id: data?.id,
            supplierName: data.supplierData?.supplierName || '--',
            expenseNo: data.dailyExpenseNo || '--',
            date: this.datePipe.transform(data.date, 'dd/MM/yyyy'),
            total: parseFloat(data.total).toFixed(2),
          },
        ];

        this.tableItems = data.dailyExpenseItemsOfExpense.map((item: any) => ({
          id: item.stationoryId,
          itemName: item.stationoryData?.stationoryName || '--',
          unitPrice: parseFloat(item.unitPrice).toFixed(2),
          quantity: parseFloat(item.quantity),
          subTotal: (
            parseFloat(item.unitPrice) * parseFloat(item.quantity)
          ).toFixed(2),
          tax: parseFloat(item.tax).toFixed(2),
          total: parseFloat(item.total).toFixed(2),
        }));
      },
      error: (error) => {
        console.error('Error fetching daily expense:', error);
      },
    });
  }

  editExpense(id: any) {
    this.router.navigate([`daily-purchase/purchase-edit/${id}`]);
  }

  onDelete(id: any) {
    const expenseId = id;
    if (!expenseId) return;
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        title: 'Confirm Deletion',
        message: `Are you sure you want to delete Expense ?`,
        confirmText: 'Delete',
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.purchaseService.deleteDailyExpense(expenseId).subscribe({
          next: () => {
            this.toastr.success('Expense deleted successfully!', 'Success');
            this.router.navigate([`daily-purchase`]);
          },
          error: (error) => {
            this.toastr.error(`Failed to delete Expense`);
            console.error('Deletion error:', error);
          },
        });
      }
    });
  }
  
}
